module.exports = __webpack_public_path__ + "static/TaylorMoy-8bcce0ef8e61aa1128a230dd5cd0578c.jpg";